module.exports = __webpack_public_path__ + "media/images/blog-f77e2f5043c379ce4a9b554000bbcf0e.png";